<template>
  <div class="page-sign-todo">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">送貨上門</div>
      <div class="breadcrumb-item">送貨上門(未簽收)</div>
    </div>

    <div class="card-block">
      <Form inline class="pg-form-inline">
        <FormItem>
          <Select
	          style="width:100%;"
	          size="small"
	          placeholder="提貨櫃點"
	          v-model="form.arrive"
	          clearable
          >
            <Option
	            :value="item.ReceivingID"
	            v-for="(item, index) in pickAddress"
	            :key="item.ReceivingID"
            >{{ item.ReceivingName }}
            </Option>
          </Select>
        </FormItem>

        <FormItem>
          <Select
	          style="width:100%;"
	          size="small"
	          placeholder="付款狀況"
	          v-model="form.pay_type"
	          clearable
          >
            <Option value="0">未在APP內付款</Option>
            <Option value="1">已在APP內付款</Option>
          </Select>
        </FormItem>

        <FormItem>
          <DatePicker
	          class="no-suffix"
	          type="datetime"
	          size="small"
	          :clearable="false"
	          placeholder="到店起始日期"
	          value-format="yyyy-MM-dd hh:mm:ss"
	          style="width: 100%;"
	          :editable="false"
	          v-model="form.start_time"
          ></DatePicker>
        </FormItem>
        <FormItem>-</FormItem>
        <FormItem>
          <DatePicker
	          class="no-suffix"
	          type="datetime"
	          size="small"
	          :clearable="false"
	          placeholder="到店結束日期"
	          value-format="yyyy-MM-dd hh:mm:ss"
	          style="width: 100%;"
	          :editable="false"
	          v-model="form.end_time"
          ></DatePicker>
        </FormItem>
      </Form>

      <Form inline class="pg-form-inline form-input-wrap">
        <FormItem>
          <label class="input-label">快遞單號</label>
          <Input
	          size="small"
	          clearable
	          v-model="form.odd_numbers"
	          @keyup.enter.native="handleSearch()"
	          clearable
          ></Input>
        </FormItem>
        <FormItem>
          <label class="input-label">客戶名稱</label>
          <Input
	          size="small"
	          clearable
	          v-model="form.username"
	          @keyup.enter.native="handleSearch()"
	          clearable
          ></Input>
        </FormItem>
        <FormItem>
          <label class="input-label">客戶電話</label>
          <Input
	          size="small"
	          clearable
	          v-model="form.phone"
	          @keyup.enter.native="handleSearch()"
	          clearable
          ></Input>
        </FormItem>
        <FormItem>
          <label class="input-label">袋號</label>
          <Input
	          size="small"
	          clearable
	          v-model="form.sack_number"
	          @keyup.enter.native="handleSearch()"
	          clearable
          ></Input>
        </FormItem>
        <FormItem>
          <div class="pg-btn-wrap">
            <div class="pg-btn style1" @click="handleSearch">搜索</div>
          </div>
        </FormItem>
      </Form>
    </div>

    <div class="card-block pd-bt">
      <Table
	      ref="table"
	      size="small"
	      border
	      no-data-text="暫無數據"
	      height="600"
	      :loading="isSubmiting"
	      @on-selection-change="handleSelectionChange"
	      :columns="table.column"
	      :data="table.data"
      >
        <template slot-scope="{ row, index }" slot="action">
          <div class="pg-btn-wrap">
            <div class="pg-btn style2" @click="handleViewOrder(index)">
              物流路徑
            </div>
            <div class="pg-btn style1" @click="handleViewRemark(index)">
              備註
            </div>
          </div>
        </template>
      </Table>

      <div class="pg-pagger">
        <Row>
          <Col span="12" class="pagger-left">
            <div class="pagger-total">總共{{ totalCount }}條記錄</div>
            <span class="total-price">件数：{{ counter }}</span>
            <span class="total-price">收款金額：{{ sums }}</span>
            <div class="pg-btn-wrap" style="margin-left: 20px;">
              <div class="pg-btn style1" @click="handleSign">
                收款並簽收(送貨上門)
              </div>
              <div class="pg-btn style1" @click="handleDelivery">
                設定送貨上門)
              </div>
            </div>
          </Col>
          <Col span="12" class="pagger-right">
            <!-- v-if="totalCount > curPageSize" -->
            <div>
              <div class="pagger-sizer">
                <span>每頁</span>
                <Select
	                v-model="curPageSize"
	                size="small"
	                placeholder="數量"
	                @on-change="handlePageSizeChange"
                >
                  <Option :value="10">10</Option>
                  <Option :value="20">20</Option>
                  <Option :value="30">30</Option>
                  <Option :value="40">40</Option>
                  <Option :value="50">50</Option>
                  <Option :value="100">100</Option>
                </Select>
              </div>

              <div class="pagger-elevator">
                <span>跳轉</span>
                <Input
	                size="small"
	                v-model="pageInput"
	                @on-keyup="handlePageInput"
	                @on-enter="handlePageEnter"
                />
              </div>

              <Page
	              size="small"
	              :current="pageIndex"
	              :page-size="curPageSize"
	              :total="totalCount"
	              @on-change="handlePageChange"
              >
              </Page>
            </div>
          </Col>
        </Row>
      </div>
    </div>

    <Modal
	    v-model="isShowModalSign"
	    title="收款並簽收(送貨上門)"
	    width="650"
	    :footer-hide="true"
	    @on-cancel="handleModalSignClose"
    >
      <div class="modal-cont">
        <div class="integral-info">
          <Spin fix class="pg-sub-loading" v-if="infoSubmiting">
            <Icon
	            type="ios-loading"
	            :size="20"
	            class="demo-spin-icon-load"
            ></Icon>
            <div class="loading-text">Loading</div>
          </Spin>
          <span
          >客戶持有的積分：<span class="spanco">{{
		          signInfo.integral + signInfo.integralTw
	          }}</span></span
          >
          <span
          >代收費金額：<span class="spanco">{{
		          Math.floor(signInfo.sum)
	          }}</span></span
          >
          <br/>
	        <!-- <span>是否免超期費：<span class="spanco">{{ this.signInfo.outtimepay }}</span>
												<span class="span-left">
														<Checkbox
															class="span-r"
															size="small"
															slot="suffix"
															v-model="checkOutTimePay"
															@on-change="changeOutTimePay"
														>
														</Checkbox>
												</span>
										</span> -->
	        <!-- <span v-if="this.signInfo.pay_status == 0">是否免附加費：<span
											class="spanco">{{ this.signInfo.surcharge_price }}</span>
												<span class="span-left">
														<Checkbox
															class="span-r"
															size="small"
															slot="suffix"
															v-model="checkAdditional"
															@on-change="changeAdditional"
														>
														</Checkbox>
												</span>
										</span> -->
          <br/>
          <span
          >送貨上門費：
            <span class="span-left">
              <Input
	              style="width: 50%;"
	              :disabled="modalForm.jpoint.isChecked"
	              v-model="delivery"
	              type="number"
	              @on-change="changeDeliverySum"
              ></Input>
            </span>
          </span>

          <span class="span-left">
            <Checkbox v-model="onlysign" :true-value="1" :false-value="0"
            >僅簽收</Checkbox
            >
          </span>
        </div>
        <hr/>
        <br/>
        <Row>
          <Col span="22" pull="1">
            <Form :label-width="150">
              <FormItem>
                <div slot="label" class="form-label">
                  <span>積分</span>
                </div>
                <div>
                  <Input
	                  v-model="modalForm.credit.value"
	                  type="number"
	                  :disabled="!modalForm.credit.isChecked"
                  >
                    <Checkbox
	                    class="input-suffix-cb"
	                    size="small"
	                    slot="suffix"
	                    v-model="modalForm.credit.isChecked"
	                    @on-change="handleModalChecbox(arguments[0], 'credit')"
                    ></Checkbox>
                  </Input>
                </div>
              </FormItem>
              <FormItem>
                <div slot="label" class="form-label">
                  <span>現金</span>
                </div>
                <div>
                  <Input
	                  v-model="modalForm.cash.value"
	                  type="number"
	                  :disabled="!modalForm.cash.isChecked"
                  >
                    <Checkbox
	                    class="input-suffix-cb"
	                    size="small"
	                    slot="suffix"
	                    v-model="modalForm.cash.isChecked"
	                    @on-change="handleModalChecbox(arguments[0], 'cash')"
                    ></Checkbox>
                  </Input>
                </div>
              </FormItem>
	            <!-- <FormItem>
																<div slot="label" class="form-label">
																		<span>澳門通</span>
																</div>
																<Input v-model="modalForm.aomentong.value" type='number'
																			 :disabled="!modalForm.aomentong.isChecked">
																		<Checkbox class="input-suffix-cb" size="small" slot="suffix"
																							v-model="modalForm.aomentong.isChecked"
																							@on-change="handleModalChecbox(arguments[0], 'aomentong')"></Checkbox>
																</Input>
														</FormItem>
														<FormItem>
																<div slot="label" class="form-label">
																		<span>MPay</span>
																</div>
																<Input v-model="modalForm.mPay.value" type='number'
																			 :disabled="!modalForm.mPay.isChecked">
																		<Checkbox class="input-suffix-cb" size="small" slot="suffix"
																							v-model="modalForm.mPay.isChecked"
																							@on-change="handleModalChecbox(arguments[0], 'mPay')"></Checkbox>
																</Input>
														</FormItem>
														<FormItem>
																 <div slot="label" class="form-label">
																		 <span>支付寶</span>
																 </div>
																 <Input v-model="modalForm.alipay.value" type='number'
																				:disabled="!modalForm.alipay.isChecked">
																		 <Checkbox class="input-suffix-cb" size="small" slot="suffix"
																							 v-model="modalForm.alipay.isChecked"
																							 @on-change="handleModalChecbox(arguments[0], 'alipay')"></Checkbox>
																 </Input>
														 </FormItem> -->
              <FormItem>
                <div slot="label" class="form-label">
                  <span>中銀(二維碼)</span>
                </div>
                <div>
                  <Input
	                  v-model="modalForm.zyPos.value"
	                  type="number"
	                  :disabled="!modalForm.zyPos.isChecked"
                  >
                    <Checkbox
	                    class="input-suffix-cb"
	                    size="small"
	                    slot="suffix"
	                    v-model="modalForm.zyPos.isChecked"
	                    @on-change="handleModalChecbox(arguments[0], 'zyPos')"
                    ></Checkbox>
                  </Input>
                </div>
              </FormItem>
	            
	            <FormItem>
                <div slot="label" class="form-label">
                  <span>集金币</span>
                </div>
                <div>
                  <Input
	                  v-model="modalForm.jpoint.value"
	                  type="number"
	                  :disabled="true"
                  >
                    <Checkbox
	                    class="input-suffix-cb"
	                    size="small"
	                    slot="suffix"
	                    v-model="modalForm.jpoint.isChecked"
	                    @on-change="handleModalChecbox(arguments[0], 'jpoint')"
                    ></Checkbox>
                  </Input>
                </div>
              </FormItem>
	            <!-- <FormItem>
																 <div slot="label" class="form-label">
																		 <span>工銀POS</span>
																 </div>
																 <Input v-model="modalForm.gyPos.value" type='number'
																				:disabled="!modalForm.gyPos.isChecked">
																		 <Checkbox class="input-suffix-cb" size="small" slot="suffix"
																							 v-model="modalForm.gyPos.isChecked"
																							 @on-change="handleModalChecbox(arguments[0], 'gyPos')"></Checkbox>
																 </Input>
														 </FormItem>

														 <FormItem>
																		<div slot="label" class="form-label">
																				<span>微信</span>
																		</div>
																		<Input v-model="modalForm.wxpay.value" type='number'
																					 :disabled="!modalForm.wxpay.isChecked">
																				<Checkbox class="input-suffix-cb" size="small" slot="suffix"
																									v-model="modalForm.wxpay.isChecked"
																									@on-change="handleModalChecbox(arguments[0], 'wxpay')"></Checkbox>
																		</Input>
														 </FormItem> -->
            </Form>
          </Col>
        </Row>
	       <Input v-if="modalForm.jpoint.isChecked" v-model="remark" type="textarea" :rows="2" placeholder="集金币签收可输入备注" />
				<div style="text-align: center;">集金币：只能做快件签收</div>
        <div class="pg-btn-wrap center">
          <div class="pg-btn style1" @click="handlePay">確定</div>
        </div>
      </div>
    </Modal>

    <Modal
	    v-model="isShowModalSign_goods"
	    title="查詢快件"
	    width="1200"
	    :footer-hide="true"
	    @on-cancel="handleModalSignClose_goods"
    >
      <div class="modal-cont">
        <Spin fix class="pg-sub-loading" v-if="isSubmitingLog">
          <Icon
	          type="ios-loading"
	          :size="20"
	          class="demo-spin-icon-load"
          ></Icon>
          <div class="loading-text">Loading</div>
        </Spin>

        <div style="font-weight:bold">快遞信息</div>
        <br/>
        <Table
	        no-data-text=""
	        :columns="table1.column"
	        :data="table1.data"
        ></Table>
        <Table
	        no-data-text=""
	        :columns="table1.column1"
	        :data="table1.data1"
        ></Table>
        <Table
	        no-data-text=""
	        :columns="table1.column2"
	        :data="table1.data2"
        ></Table>
        <Table no-data-text="" :columns="table1.column3" :data="table1.data3">
          <template slot-scope="{ row, index }" slot="status">
            <span v-if="row.status == 0">珠海倉庫-待出庫</span>
            <span v-else-if="row.status == 1">珠海倉庫-已出庫</span>
            <span v-else-if="row.status == 2">澳門倉庫-配送中</span>
            <span v-else-if="row.status == 3">澳門門店/智能櫃-未簽收</span>
            <span v-else-if="row.status == 4">澳門門店/智能櫃-已簽收</span>
          </template>
        </Table>
        <Table
	        no-data-text=""
	        :columns="table1.column4"
	        :data="table1.data4"
        ></Table>
        <Table
	        no-data-text=""
	        :columns="table1.column5"
	        :data="table1.data5"
        ></Table>
        <br/><br/>
        <div style="font-weight:bold">物流信息</div>
        <br/>
        <div class="step-wrap" v-if="detail && detail.length">
          <div
	          class="step-item clearfix"
	          v-for="(item, index) in detail"
	          :key="item.id"
          >
            <div class="left">
              <div class="l-date">
                <span>{{ item.date }}</span>
                <span>{{ item.week }}</span>
              </div>
              <div class="l-time">{{ item.time }}</div>
            </div>
            <div class="right">
              <div class="r-address">
                {{ item.describe }} , 操作人：{{ item.userinfos }}
              </div>
            </div>
          </div>
        </div>

        <div class="data-null" v-else>
          <!-- <img src="../../../assets/images/null-data.png" alt="" draggable="false"> -->
          <div>暫無數據</div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Store from '../../../assets/js/store.js'

let isthis
export default {
	data() {
		return {
			value8: false,
			successAudio: 'music-success.mp3', //成功音效
			errorAudio: 'music-fail.mp3', //失敗音效
			pageIndex: 1, //頁碼
			curPageSize: 10, //一頁數量
			pageInput: '', //輸入的頁碼
			totalCount: 1, //總條數
			pickAddress: [], //提貨櫃點
			pickShelves: [], //貨架號
			samcityType: [], //同城
			account_permission: Store.fetch().type,
			form: {
				arrive: '', //提貨櫃點id
				start_time: '', //起始日期
				end_time: '', //結束日期
				odd_numbers: '', //快遞單號
				phone: '', //電話號碼
				sack_number: '', //袋號
				shelves: '', //貨架號
				username: '', //用户名稱
				pay_type: '',
			},
			offline_activity: '',
			outtimepay: '',
			pay_type: '',
			sums: 0,
			isSubmiting: false,
			isSubmiting_notonshelf: false,
			infoSubmiting: false,
			checkOutTimePay: false,
			additional: '', // 附加費
			checkAdditional: false,
			checkOutDelivery: false,
			checkOutTimePay_jpoint: false,
			checkAdditional_jpoint: false,
			checkOutDelivery_jpoint: false,
			isSubmitingLog: false,
			counter: 0, // 勾选的件数
			
			table_no_shelf: {
				column: [
					{
						title: '日期',
						key: 'out_time',
						align: 'center',
						sortable: true,
						minWidth: 100,
						className: 'demo-table-info-column',
					},
					{
						title: '快遞單號',
						key: 'odd_numbers',
						align: 'center',
						sortable: true,
						minWidth: 150,
						className: 'demo-table-info-column',
					},
					{
						title: '公司名稱',
						key: 'order_parent_name',
						align: 'center',
						sortable: true,
						minWidth: 100,
						className: 'demo-table-info-column',
					},
					{
						title: '門店',
						key: 'ReceivingName',
						align: 'center',
						sortable: true,
						minWidth: 100,
						className: 'demo-table-info-column',
					},
					{
						title: '未上架(日:時間)',
						key: 'on_shelf_days',
						align: 'center',
						sortable: true,
						minWidth: 100,
						className: 'demo-table-info-column',
					},
					{
						title: '備註說明',
						key: 'remarks',
						align: 'center',
						sortable: true,
						minWidth: 160,
						className: 'demo-table-info-column',
					},
				],
				data: [],
			},
			
			table: {
				column: [
					{
						type: 'selection',
						width: 60,
						align: 'center',
						fixed: 'left'
					},
					{
						title: '操作',
						slot: 'action',
						align: 'center',
						minWidth: 150,
						fixed: 'left'
					},
					
					// {
					//     title: '貨架號',
					//     key: 'shelves',
					//     align: 'center',
					//     minWidth: 80,
					//     sortable: true
					// },
					// {
					//     title: '同城快件',
					//     key: 'goods_type',
					//     align: 'center',
					//     minWidth: 60,
					//     sortable: true
					// },
					{
						title: '客戶名稱【積分】',
						key: 'recipient_contacts',
						align: 'center',
						minWidth: 200,
						sortable: true,
					},
					{
						title: '客戶電話',
						key: 'recipient_phone',
						align: 'center',
						minWidth: 130,
						sortable: true,
					},
					{
						title: '快遞單號',
						key: 'odd_numbers',
						align: 'center',
						minWidth: 150,
						sortable: true,
					},
					{
						title: '取貨櫃點',
						key: 'receivingName',
						align: 'center',
						minWidth: 150,
					},
					{
						title: '付款狀況',
						key: 'pay_type',
						align: 'center',
						minWidth: 130,
						sortable: true,
					},
					{
						title: '代收費',
						key: 'amount',
						align: 'center',
						minWidth: 50,
						sortable: true,
						className: 'demo-table-info-cell-name',
					},
					{
						title: '到付運費',
						key: 'freight_collect',
						align: 'center',
						minWidth: 50,
						sortable: true,
						className: 'demo-table-info-cell-name',
					},
					{
						title: '加收附加費',
						key: 'surcharge_price',
						align: 'center',
						minWidth: 50,
						sortable: true,
						className: 'demo-table-info-cell-name',
					},
					{
						title: '超期費',
						key: 'outtimepay',
						align: 'center',
						minWidth: 50,
						sortable: true,
						className: 'demo-table-info-cell-name',
					},
					{
						title: 'APP立減費',
						key: 'offline_activity',
						align: 'center',
						minWidth: 50,
						sortable: true,
						className: 'demo-table-info-cell-name',
					},
					{
						title: '合計費用',
						key: 'sum',
						align: 'center',
						minWidth: 50,
						sortable: true,
						className: 'demo-table-info-cell-name-sum',
					},
					{
						title: '珠海仓出库时间',
						key: 'out_time',
						align: 'center',
						sortable: true,
						minWidth: 160,
					},
					{
						title: '到達門店時間',
						key: 'arrive_time',
						align: 'center',
						sortable: true,
						minWidth: 160,
					},
					{
						title: '上架天數',
						key: 'save_time',
						align: 'center',
						minWidth: 80,
						sortable: true,
					},
					{
						title: '袋號',
						key: 'sack_number',
						align: 'center',
						sortable: true,
						minWidth: 130,
					},
					{
						title: '品名',
						key: 'productName',
						align: 'center',
						sortable: true,
						minWidth: 130,
					},
					{
						title: '備註',
						key: 'remarks',
						align: 'center',
						sortable: true,
						minWidth: 160,
					},
				],
				data: [],
			},
			
			table1: {
				column: [
					{
						title: '快遞單號',
						key: 'order',
						align: 'center',
						minWidth: 80,
					},
					{
						title: '客戶電話',
						key: 'phone',
						align: 'center',
						minWidth: 80,
					},
					{
						title: '客戶名稱',
						key: 'username',
						align: 'center',
						minWidth: 80,
					},
				],
				column1: [
					{
						title: '重量',
						key: 'weight',
						align: 'center',
						minWidth: 100,
					},
					{
						title: '尺寸',
						key: 'size_sum',
						align: 'center',
						minWidth: 100,
					},
					{
						title: '提貨櫃點',
						key: 'store',
						align: 'center',
						minWidth: 100,
					},
				],
				column2: [
					{
						title: '快件明細',
						key: 'detailed',
						align: 'center',
						minWidth: 100,
					},
					{
						title: '異常件',
						key: 'abnormal',
						align: 'center',
						minWidth: 100,
					},
					{
						title: '出庫袋號',
						key: 'sack_number',
						align: 'center',
						minWidth: 100,
					},
				],
				column3: [
					{
						title: '最新貨態',
						slot: 'status',
						align: 'center',
						minWidth: 100,
					},
					{
						title: '更新時間',
						key: 'created_time',
						align: 'center',
						minWidth: 100,
					},
					{
						title: '貨架號',
						key: 'shelves',
						align: 'center',
						minWidth: 100,
					},
				],
				column4: [
					{
						title: '代收費',
						key: 'amount',
						align: 'center',
						minWidth: 100,
					},
					{
						title: '附加費',
						key: 'surcharge_price',
						align: 'center',
						minWidth: 100,
					},
					{
						title: '到附運費',
						key: 'freight_collect',
						align: 'center',
						minWidth: 100,
					},
				],
				column5: [
					{
						title: '超期費',
						key: 'outTime_price',
						align: 'center',
						minWidth: 100,
					},
					{
						title: '合計費用',
						key: 'total_price',
						align: 'center',
						minWidth: 100,
					},
				],
				data: [],
				data1: [],
				data2: [],
				data3: [],
				data4: [],
				data5: [],
			},
			detail: [],
			
			isShowModalSign: false, //收款并签收信息
			isShowModalSign_jpoint: false, //JPOINT收款并签收信息
			isShowModalSign_goods: false, //Goods信息
			
			curCheckedList: [], //当前选中的数据
			signInfo: {},
			
			isPaying: false,
			delivery: 0, // 送货上门费
			onlysign: 0,
			modalForm: {
				credit: {
					value: 0,
					isChecked: true,
				},
				cash: {
					value: 0,
					isChecked: false,
				},
				aomentong: {
					value: 0,
					isChecked: false,
				},
				mPay: {
					value: 0,
					isChecked: false,
				},
				zyPos: {
					value: 0,
					isChecked: false,
				},
				gyPos: {
					value: 0,
					isChecked: false,
				},
				alipay: {
					value: 0,
					isChecked: false,
				},
				wxpay: {
					value: 0,
					isChecked: false,
				},
				jpoint: {
					value: 0,
					isChecked: false,
				},
				delivery: {
					value: 0,
					isChecked: false,
				},
			},
			remark: ''
		}
	},
	created() {
		isthis = this
		this.getPickAddress()
	},
	mounted() {
		// this.getList(this.form.arrive);
	},
	activated() {
		this.getList(this.form.arrive)
	},
	methods: {
		// 计算送货上门费
		changeDeliverySum() {
			let modalForm = this.modalForm
			console.log(this.delivery)
			if (!this.delivery) {
				this.delivery = 0
			}
			for (let key in modalForm) {
				if (modalForm[key].isChecked == true) {
					modalForm[key].value =
						parseFloat(this.signInfo.sum) + parseFloat(this.delivery) + ''
				}
			}
			this.modalForm = modalForm
		},
		getPickAddress() {
			//提貨櫃點
			this.$Rq
				.requestAuth({
					url: this.$Api.deliveryListToShop,
					method: 'post',
				})
				.then((res) => {
					if (res.code == 0) {
						this.pickAddress = res.data
						this.pickAddress.unshift({
							ReceivingID: '',
							ReceivingName: '请选择',
							delivery: 0,
						})
						if (res.data.length > 0) {
							// this.form.arrive = res.data[0].ReceivingID;
						}
					}
				})
			this.getList(this.form.arrive)
		},
		handleViewOrder(index) {
			this.isShowModalSign_goods = true
			this.isSubmitingLog = true
			let tableData = this.table.data
			
			this.$Rq
				.requestAuth({
					url: this.$Api.all_search,
					method: 'get',
					data: {
						order: tableData[index].odd_numbers,
					},
				})
				.then((res) => {
					this.isSubmitingLog = false
					let tempArr = []
					let tempArr1 = []
					let tempArr2 = []
					let tempArr3 = []
					let tempArr4 = []
					let tempArr5 = []
					let resData = res.data
					
					if (res.code == 0) {
						for (let i = 0; i < resData.data.length; i++) {
							tempArr.push({
								order: resData.data[i].order,
								username: resData.data[i].username,
								phone: resData.data[i].phone,
							})
							
							tempArr1.push({
								weight: resData.data[i].weight,
								size_sum:
									resData.data[i].long +
									'x' +
									resData.data[i].width +
									'x' +
									resData.data[i].height,
								store:
									resData.data[i].store == null
										? '- - -'
										: resData.data[i].store.ReceivingName,
							})
							
							tempArr2.push({
								sack_number: resData.data[i].sack_number,
								detailed:
									resData.data[i].detailed == null
										? '- - -'
										: resData.data[i].detailed.name,
								abnormal: resData.data[i].abnormal == 0 ? '否' : '是',
							})
							
							tempArr3.push({
								shelves:
									resData.data[i].shelves == null
										? '- - -'
										: resData.data[i].shelves.code,
								status: resData.data[i].status,
								created_time: resData.data[i].created_time,
							})
							
							tempArr4.push({
								amount: resData.data[i].amount,
								surcharge_price: resData.data[i].surcharge_price,
								freight_collect: resData.data[i].freight_collect,
							})
							
							tempArr5.push({
								outTime_price: resData.data[i].outTime_price,
								total_price:
									Number(resData.data[i].surcharge_price) +
									Number(resData.data[i].outTime_price) +
									Number(resData.data[i].freight_collect) +
									Number(resData.data[i].amount),
							})
						}
						this.table1.data = tempArr
						this.table1.data1 = tempArr1
						this.table1.data2 = tempArr2
						this.table1.data3 = tempArr3
						this.table1.data4 = tempArr4
						this.table1.data5 = tempArr5
					}
				})
				.catch((err) => {
					this.isSubmitingLog = false
				})
			
			this.isSubmitingLog = true
			this.$Rq
				.requestAuth({
					url: this.$Api.logisticsInfo + '/' + tableData[index].odd_numbers,
					method: 'get',
					data: {},
				})
				.then((res) => {
					this.isSubmitingLog = false
					if (res.code == 0) {
						let resData = res.data
						let tempArr = []
						let userinfo
						
						for (let i = 0; i < resData.length; i++) {
							let datetime = this.getDateTime(resData[i].created_at)
							
							if (resData[i].userinfos == null) {
								if (resData[i].remarks.match(/[\u606d\u559c\u60a8]/g)) {
									userinfo = '用戶線上支付'
								} else {
									if (resData[i].admin_name != null) {
										userinfo = resData[i].admin_name
									} else {
										userinfo = '智能櫃派送員'
									}
								}
							} else {
								userinfo = resData[i].userinfos.username
							}
							
							tempArr.push({
								userinfos: userinfo,
								id: resData[i].id,
								date: datetime.date,
								week: datetime.week,
								time: datetime.time,
								describe: resData[i].remarks,
							})
						}
						
						this.detail = tempArr
					}
				})
				.catch((err) => {
					this.isSubmitingLog = false
				})
		},
		handleViewRemark(index) {
			let tableData = this.table.data
			this.$router.push({
				path: '/shopSignetodoRemark?id=' + tableData[index].remark_id,
			})
		},
		getDateTime(datetime) {
			let date = new Date(datetime)
			let year = date.getFullYear()
			let month = date.getMonth() + 1
			let day = date.getDate()
			let hour = date.getHours()
			let minute = date.getMinutes()
			let second = date.getSeconds()
			let week = date.getDay()
			let weekList = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
			
			return {
				date: `${this.formateNum_log(year)}-${this.formateNum_log(
					month
				)}-${this.formateNum_log(day)}`,
				time: `${this.formateNum_log(hour)}:${this.formateNum_log(
					minute
				)}:${this.formateNum_log(second)}`,
				week: weekList[week],
			}
		},
		formateNum_log(num) {
			return num > 9 ? num : '0' + num
		},
		formatDate(datetime) {
			if (!datetime) return ''
			let dateTime = new Date(datetime)
			let year = dateTime.getFullYear()
			let month = dateTime.getMonth() + 1
			let date = dateTime.getDate()
			let hour = dateTime.getHours()
			let minute = dateTime.getMinutes()
			let second = dateTime.getSeconds()
			let milliseconds = dateTime.getMilliseconds()
			return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(
				date
			)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(
				milliseconds
			)}`
		},
		formatNum(num) {
			return num < 10 ? '0' + num : num
		},
		arrive_time_count(date1) {
			var date1 = date1
			var date2 = new Date()
			var date3 = date2.getTime() - new Date(date1).getTime()
			var subMinutes = Math.floor(date3 / (60 * 1000))
			var days = Math.floor(date3 / (24 * 3600 * 1000))
			var leave1 = date3 % (24 * 3600 * 1000)
			var hours = Math.floor(leave1 / (3600 * 1000))
			var leave2 = leave1 % (3600 * 1000)
			var minutes = Math.floor(leave2 / (60 * 1000))
			var leave3 = leave2 % (60 * 1000)
			var seconds = Math.round(leave3 / 1000)
			return days
		},
		getList(arrive) {
			let form = this.form
			this.isSubmiting = true
			this.$Rq
				.requestAuth({
					url: this.$Api.scanIn,
					method: 'get',
					data: {
						status: -4,
						offset: (this.pageIndex - 1) * this.curPageSize,
						limit: this.curPageSize,
						arrive: arrive,
						start_time: this.formatDate(form.start_time),
						end_time: this.formatDate(form.end_time),
						odd_numbers: form.odd_numbers,
						phone: form.phone,
						macao_originating: 1,
						sack_number: form.sack_number,
						username: form.username,
						pay_type: form.pay_type,
						arrive_code: form.shelves,
						admin_id: form.admin_id,
					},
				})
				.then((res) => {
					this.isSubmiting = false
					if (res.code == 0) {
						let tempArr = []
						let class_temp = []
						let class_pay_type = []
						let samecity
						let resData = res.data.data
						let amount_count
						
						for (let i = 0; i < resData.length; i++) {
							let integral_tw = 0
							if (resData[i].user != null) {
								for (let j = 0; j < resData[i].user.tw.length; j++) {
									let integral_tw_count = Number(resData[i].user.tw[j].integral)
									integral_tw += integral_tw_count
								}
							}
							
							if (resData[i].pay_type == 0) {
								class_pay_type[i] = ''
							} else {
								class_pay_type[i] = 'demo-table-app-row'
							}
							
							// if (this.arrive_time_count(resData[i].arrive_time) >= 7) {
							//   class_temp[i] = 'demo-table-info-row';
							// } else if (this.arrive_time_count(resData[i].arrive_time) >= 2) {
							//   class_temp[i] = 'demo-table-error-row';
							// } else {
							//   class_temp[i] = '';
							// }
							
							if (resData[i].goods_type == 2) {
								if (resData[i].type == 1) {
									amount_count = Number(resData[i].amount)
								}
								if (resData[i].type == 2) {
									amount_count = Number(0)
								}
								if (resData[i].type == 3) {
									amount_count = Number(0)
								}
								
								if (resData[i].pay_type == 0) {
									samecity = '未在APP內付款'
								} else {
									samecity = '已在APP內付款'
								}
							} else {
								amount_count = Number(resData[i].amount)
								
								if (resData[i].pay_type == 0) {
									samecity = '未在APP內付款'
								} else {
									samecity = '已在APP內付款'
								}
							}
							
							let type
							
							if (resData[i].type == 1) {
								type = '收方付費'
							} else if (resData[i].type == 2) {
								type = '商家餘額'
							} else if (resData[i].type == 3) {
								type = '商家月結'
							}
							
							let arrive_save
							
							if (resData[i].arrive_time == null) {
								arrive_save = new Date()
							} else {
								arrive_save = resData[i].arrive_time
							}
							
							tempArr.push({
								remark_id: resData[i].id,
								
								user_id:
									resData[i].user == null ? '- - -' : resData[i].user.user_id,
								
								recipient_contacts:
									resData[i].user == null
										? resData[i].recipient_contacts
										: resData[i].recipient_contacts +
										'【' +
										(resData[i].user.user_integral + integral_tw) +
										'】', //客戶名稱【積分】
								
								jpoint:
									resData[i].user?.jpoint == null
										? 0
										: Number(resData[i].user.jpoint / 100),
								
								recipient_phone: resData[i].recipient_phone, //客戶電話
								
								odd_numbers: resData[i].odd_numbers, //出貨單號
								
								shelves:
									resData[i].shelves == null
										? '- - -'
										: resData[i].shelves.code, //貨架號
								
								// pay_type: resData[i].pay_type == 0 ? '未在APP內付款' : '已在APP內付款', //付款状况
								
								pay_type: samecity,
								
								sum:
									amount_count +
									Number(resData[i].freight_collect) +
									Number(resData[i].surcharge_price) +
									Number(resData[i].outtimepays || 0) -
									Number(
										resData[i].orderamount == null
											? 0
											: resData[i].orderamount.discount
									), //合計費用
								
								freight_collect: Number(resData[i].freight_collect), // 到付運費
								
								surcharge_price: Number(resData[i].surcharge_price), // 加收附加費
								
								outtimepay: resData[i].outtimepays ? resData[i].outtimepays : 0, //超期費
								
								amount: amount_count, // 代收費
								
								offline_activity:
									resData[i].orderamount == null
										? 0
										: '-' + resData[i].orderamount.discount, // 門店立減費
								
								receivingName:
									resData[i].store == null
										? '- - -'
										: resData[i].store.ReceivingName, //取貨櫃點
								
								sack_number: resData[i].sack_number, //袋號
								
								productName: resData[i].detailed.name, //品名
								
								arrive_time:
									resData[i].arrive_time == null
										? '- - -'
										: resData[i].arrive_time, // 到店時間
								
								remarks:
									resData[i].remarks == null ? '- - -' : resData[i].remarks, //備註
								
								out_time:
									resData[i].out_time == null ? '- - -' : resData[i].out_time, //出库时间
								
								goods_type:
									resData[i].goods_type != 2 ? '否' : '是' + ' (' + type + ')', //同城類型
								
								save_time: this.arrive_time_count(arrive_save),
								cellClassName: {
									//記錄
									save_time: class_temp[i],
									pay_type: class_pay_type[i],
								},
							})
						}
						console.log(tempArr)
						this.totalCount = res.data.count
						this.table.data = tempArr
					} else {
						this.showTipInfo(res.msg)
					}
				})
				.catch((err) => {
					this.isSubmiting = false
				})
		},
		getSignInfo() {
			//签收获取积分和收款金额
			
			this.isSubmiting = true
			
			let odd_numbers = this.curCheckedList.map((item, index) => {
				return item.odd_numbers
			})
			let amount = this.curCheckedList.map((item, index) => {
				return item.amount
			})
			let offline_activity = this.curCheckedList.map((item, index) => {
				return item.offline_activity
			})
			let outtimepay = this.curCheckedList.map((item, index) => {
				return item.outtimepay
			})
			let pay_type = this.curCheckedList.map((item, index) => {
				return item.pay_type
			})
			
			this.$Rq
				.requestAuth({
					url: this.$Api.getSignInfos,
					method: 'post',
					data: {
						odd_numbers,
						amount,
					},
				})
				.then((res) => {
					this.isSubmiting = false
					
					if (res.code == 0) {
						for (var i = 0; i < pay_type.length; i++) {
							if (pay_type[0] != pay_type[i]) {
								this.$Modal.error({
									title: '警告',
									content: '不能混合簽收',
								})
								return
							} else {
								var pay_type_condition = true
							}
						}
						
						if (pay_type_condition == true) {
							if (res.data.pay_status === 1) {
								this.signInfo = res.data
								this.offline_activity = offline_activity[0]
								
								var sum_offline_activity = 0
								for (let i = 0; i < offline_activity.length; i++) {
									sum_offline_activity += Math.abs(offline_activity[i])
								}
								this.signInfo.pay_status = res.data.pay_status
								this.signInfo.offline_activity = sum_offline_activity
								this.signInfo.sum = res.data.amount || 0 //總費用 = 代收費+超期費+到附運費+立減3元
								this.signInfo.outtimepay = res.data.outtimepay || 0 //超期費
								this.signInfo.surcharge_price = res.data.surcharge_price || 0 //附加費
								this.signInfo.integralTw = res.data.integralTw || 0
								this.signInfo.count = res.data.amount || 0 //代收費+到附運費
								this.signInfo.delivery = res.data.delivery
								this.signInfo.pay_status = res.data.pay_status
								
								if (this.signInfo.sum > this.signInfo.integral) {
									this.modalForm.cash.value = Math.floor(this.signInfo.sum)
									this.modalForm.cash.isChecked = true
									this.modalForm.credit.isChecked = false
								} else {
									this.modalForm.credit.value = Math.floor(this.signInfo.sum)
									this.modalForm.credit.isChecked = true
									this.modalForm.cash.isChecked = false
								}
								this.handleModalSignShow()
							}
							
							if (res.data.pay_status === 0) {
								this.signInfo = res.data
								this.offline_activity = offline_activity[0]
								
								var sum_offline_activity = 0
								for (let i = 0; i < offline_activity.length; i++) {
									sum_offline_activity += Math.abs(offline_activity[i])
								}
								
								this.signInfo.pay_status = res.data.pay_status
								this.signInfo.offline_activity = sum_offline_activity
								this.signInfo.sum = res.data.amount || 0 //總費用 = 代收費 + 超期費 + 到附運費 + 立減3元
								this.signInfo.outtimepay = res.data.outtimepay || 0 //超期費
								this.signInfo.surcharge_price = res.data.surcharge_price || 0 //附加費
								this.signInfo.count = res.data.amount || 0 //代收費 + 到附運費
								this.signInfo.integralTw = res.data.integralTw || 0
								this.signInfo.delivery = res.data.delivery
								this.signInfo.pay_status = res.data.pay_status
								
								if (this.signInfo.sum > this.signInfo.integral) {
									this.modalForm.cash.value = Math.floor(this.signInfo.sum)
									this.modalForm.cash.isChecked = true
									this.modalForm.credit.isChecked = false
								} else {
									this.modalForm.credit.value = Math.floor(this.signInfo.sum)
									this.modalForm.credit.isChecked = true
									this.modalForm.cash.isChecked = false
								}
								this.handleModalSignShow()
							}
						}
					}
				})
				.catch((err) => {
					this.isSubmiting = false
				})
		},
		handleViewWuliu(index) {
			let tableData = this.table.data
			this.$router.push({
				path:
					'/shopSigntodologisticsInfo?orderNo=' + tableData[index].odd_numbers,
			})
		},
		handleSearch() {
			this.pageIndex = 1
			isthis.sums = 0
			this.getList(this.form.arrive)
		},
		handleModalSignShow() {
			//收款並簽收弹窗显示隐藏
			this.isShowModalSign = true
		},
		handleModalSignClose() {
			let modalForm = this.modalForm
			for (let key in modalForm) {
				modalForm[key].isChecked = false
				modalForm[key].value = ''
			}
			this.delivery = 0
			this.onlysign = 0
			this.checkAdditional = false
			this.checkOutTimePay = false
			this.checkOutDelivery = false
			this.isShowModalSign = false
		},
		handleModalSignClose_goods() {
			this.isShowModalSign_goods = false
		},
		handleModalChecbox(value, field) {
			let modalForm = this.modalForm
			
			for (let key in modalForm) {
				modalForm[key].isChecked = false
			}
			
			modalForm[field].isChecked = value
			this.modalForm = modalForm
			
			for (let key in modalForm) {
				if (modalForm[key].isChecked == false) {
					modalForm[key].value = 0
				} else {
					modalForm[key].isChecked = true
					modalForm[key].value =
						parseFloat(this.signInfo.sum) + parseFloat(this.delivery) + ''
				}
			}
		},
		handleSign() {
			//收款並簽收
			if (!this.table.data.length) {
				this.$Utils.showTipInfo('暂時沒有數據')
				return
			}
			
			this.curCheckedList = this.$refs.table.getSelection()
			if (!this.curCheckedList.length) {
				this.$Utils.showTipInfo('請先勾選數據')
				return
			}
			this.remark = '';
			this.getSignInfo()
		},
		// 設定送貨上門
		handleDelivery() {
			let checkedList = this.$refs.table.getSelection()
			if (!checkedList.length) {
				return this.$Message.error('請勾選數據')
			}
			let order = checkedList.map((item) => item.odd_numbers)
			
			this.$Rq
				.requestAuth({
					url: this.$Api.moreDelivery,
					method: 'post',
					data: {
						order,
						ReceivingID: 132,
					},
				})
				.then((res) => {
					this.$Message.success(res.msg)
				})
		},
		changeAdditional() {
			let modalForm = this.modalForm
			if (this.checkAdditional) {
				if (this.checkOutTimePay) {
					console.log('免附加费+免超时费')
					for (let key in modalForm) {
						if (modalForm[key].isChecked == false) {
							modalForm[key].value = 0
						} else {
							if (this.signInfo.count - this.signInfo.offline_activity <= 0) {
								modalForm[key].value = 0
							} else {
								modalForm[key].value = Math.floor(
									this.signInfo.count - this.signInfo.offline_activity
								)
								// console.log(Math.floor(this.signInfo.count));
							}
						}
					}
					if (this.signInfo.count - this.signInfo.offline_activity <= 0) {
						this.signInfo.sum = 0
					} else {
						this.signInfo.sum = Math.floor(
							this.signInfo.count - this.signInfo.offline_activity
						)
					}
				} else {
					console.log('免附加费+不免超时费')
					for (let key in modalForm) {
						if (modalForm[key].isChecked == false) {
							modalForm[key].value = 0
						} else {
							if (
								this.signInfo.count +
								this.signInfo.outtimepay -
								this.signInfo.offline_activity <=
								0
							) {
								modalForm[key].value == 0
							} else {
								modalForm[key].value = Math.floor(
									this.signInfo.count +
									this.signInfo.outtimepay -
									this.signInfo.offline_activity +
									Number(this.delivery)
								)
							}
						}
					}
					if (
						this.signInfo.count +
						this.signInfo.outtimepay -
						this.signInfo.offline_activity <=
						0
					) {
						this.signInfo.sum = 0
					} else {
						this.signInfo.sum =
							this.signInfo.count +
							this.signInfo.outtimepay -
							this.signInfo.offline_activity
					}
				}
			} else {
				if (this.checkOutTimePay) {
					console.log('不免附加费+免超时费')
					for (let key in modalForm) {
						if (modalForm[key].isChecked == false) {
							modalForm[key].value = 0
						} else {
							if (
								this.signInfo.count +
								this.signInfo.surcharge_price -
								this.signInfo.offline_activity <=
								0
							) {
								modalForm[key].value = 0
							} else {
								modalForm[key].value = Math.floor(
									this.signInfo.count +
									this.signInfo.surcharge_price -
									this.signInfo.offline_activity +
									Number(this.delivery)
								)
							}
						}
					}
					if (
						this.signInfo.count +
						this.signInfo.surcharge_price -
						this.signInfo.offline_activity <=
						0
					) {
						this.signInfo.sum = 0
					} else {
						this.signInfo.sum =
							this.signInfo.count +
							this.signInfo.surcharge_price -
							this.signInfo.offline_activity
					}
				} else {
					console.log('不免附加费+不免超时费')
					for (let key in modalForm) {
						if (modalForm[key].isChecked == false) {
							modalForm[key].value = 0
						} else {
							if (
								this.signInfo.count +
								this.signInfo.surcharge_price +
								this.signInfo.outtimepay -
								this.signInfo.offline_activity <=
								0
							) {
								modalForm[key].value = 0
							} else {
								modalForm[key].value = Math.floor(
									this.signInfo.count +
									this.signInfo.surcharge_price +
									this.signInfo.outtimepay -
									this.signInfo.offline_activity +
									Number(this.delivery)
								)
							}
						}
					}
					if (
						this.signInfo.count +
						this.signInfo.surcharge_price +
						this.signInfo.outtimepay -
						this.signInfo.offline_activity <=
						0
					) {
						this.signInfo.sum = 0
					} else {
						this.signInfo.sum =
							this.signInfo.count +
							this.signInfo.surcharge_price +
							this.signInfo.outtimepay -
							this.signInfo.offline_activity
					}
				}
			}
		},
		changeOutTimePay() {
			let modalForm = this.modalForm
			if (this.checkOutTimePay) {
				if (this.checkAdditional) {
					console.log('免超时费+免附加费')
					for (let key in modalForm) {
						if (modalForm[key].isChecked == false) {
							modalForm[key].value = 0
						} else {
							if (
								Math.floor(
									this.signInfo.count - this.signInfo.offline_activity
								) <= 0
							) {
								modalForm[key].value = 0
							} else {
								modalForm[key].value = Math.floor(
									this.signInfo.count - this.signInfo.offline_activity
								)
							}
						}
					}
					if (this.signInfo.count - this.signInfo.offline_activity <= 0) {
						this.signInfo.sum = 0
					} else {
						this.signInfo.sum = Math.floor(
							this.signInfo.count - this.signInfo.offline_activity
						)
					}
				} else {
					console.log('免超时费+不免附加费')
					
					if (this.signInfo.pay_status == 1) {
						for (let key in modalForm) {
							if (modalForm[key].isChecked == false) {
								modalForm[key].value = 0
							} else {
								if (this.signInfo.count - this.signInfo.offline_activity <= 0) {
									modalForm[key].value = 0
								} else {
									modalForm[key].value = Number(
										this.signInfo.count - this.signInfo.offline_activity
									)
								}
							}
						}
						if (this.signInfo.count - this.signInfo.offline_activity <= 0) {
							this.signInfo.sum = 0
						} else {
							this.signInfo.sum = Number(
								this.signInfo.count - this.signInfo.offline_activity
							)
						}
					}
					
					if (this.signInfo.pay_status == 0) {
						for (let key in modalForm) {
							if (modalForm[key].isChecked == false) {
								modalForm[key].value = 0
							} else {
								if (
									this.signInfo.count +
									this.signInfo.surcharge_price -
									this.signInfo.offline_activity <=
									0
								) {
									modalForm[key].value = 0
								} else {
									modalForm[key].value = Number(
										this.signInfo.count +
										this.signInfo.surcharge_price -
										this.signInfo.offline_activity
									)
								}
							}
						}
						if (
							this.signInfo.count +
							this.signInfo.surcharge_price -
							this.signInfo.offline_activity <=
							0
						) {
							this.signInfo.sum = 0
						} else {
							this.signInfo.sum = Number(
								this.signInfo.count +
								this.signInfo.surcharge_price -
								this.signInfo.offline_activity
							)
						}
					}
				}
			} else {
				if (this.checkAdditional) {
					console.log('不免超时费+免附加费')
					
					for (let key in modalForm) {
						if (modalForm[key].isChecked == false) {
							modalForm[key].value = 0
						} else {
							if (
								this.signInfo.count +
								this.signInfo.outtimepay -
								this.signInfo.offline_activity <=
								0
							) {
								modalForm[key].value = 0
							} else {
								modalForm[key].value = Math.floor(
									this.signInfo.count +
									this.signInfo.outtimepay -
									this.signInfo.offline_activity
								)
							}
						}
					}
					if (
						this.signInfo.count +
						this.signInfo.outtimepay -
						this.signInfo.offline_activity <=
						0
					) {
						this.signInfo.sum = 0
					} else {
						this.signInfo.sum =
							this.signInfo.count +
							this.signInfo.outtimepay -
							this.signInfo.offline_activity
					}
				} else {
					console.log('不免超时费+不免附加费')
					
					if (this.signInfo.pay_status == 1) {
						for (let key in modalForm) {
							if (modalForm[key].isChecked == false) {
								modalForm[key].value = 0
							} else {
								if (this.signInfo.count + this.signInfo.outtimepay <= 0) {
									modalForm[key].value = 0
								} else {
									modalForm[key].value = Math.floor(
										this.signInfo.count + this.signInfo.outtimepay
									)
								}
							}
						}
						if (this.signInfo.count + this.signInfo.outtimepay <= 0) {
							this.signInfo.sum = 0
						} else {
							this.signInfo.sum = this.signInfo.count + this.signInfo.outtimepay
						}
					}
					
					if (this.signInfo.pay_status == 0) {
						for (let key in modalForm) {
							if (modalForm[key].isChecked == false) {
								modalForm[key].value = 0
							} else {
								if (
									this.signInfo.count +
									this.signInfo.surcharge_price +
									this.signInfo.outtimepay -
									this.signInfo.offline_activity <=
									0
								) {
									modalForm[key].value = 0
								} else {
									modalForm[key].value = Math.floor(
										this.signInfo.count +
										this.signInfo.surcharge_price +
										this.signInfo.outtimepay -
										this.signInfo.offline_activity
									)
								}
							}
						}
						if (
							this.signInfo.count +
							this.signInfo.surcharge_price +
							this.signInfo.outtimepay -
							this.signInfo.offline_activity <=
							0
						) {
							this.signInfo.sum = 0
						} else {
							this.signInfo.sum =
								this.signInfo.count +
								this.signInfo.surcharge_price +
								this.signInfo.outtimepay -
								this.signInfo.offline_activity
						}
					}
				}
			}
		},
		handlePay() {
			//确定付款
			this.infoSubmiting = true
			//获取支付方式
			let modalForm = this.modalForm
			let data = {}
			let odd_numbers = this.curCheckedList.map((item, index) => {
				return item.odd_numbers
			})
			
			// 判斷金額
			// if(this.signInfo.sum != (Math.floor(this.modalForm.credit.value) + Math.floor(this.modalForm.cash.value) + Math.floor(this.modalForm.zyPos.value) + Math.floor(this.modalForm.mPay.value) + Math.floor(this.modalForm.aomentong.value) + Math.floor(this.modalForm.alipay.value) + Math.floor(this.modalForm.wxpay.value) + Math.floor(this.modalForm.gyPos.value))){
			
			//     this.$Utils.showTipInfo('金額不匹配');
			//     this.infoSubmiting = false;
			//     return;
			// }
			console.log(modalForm.jpoint.isChecked)
			if (
				!modalForm.credit.isChecked &&
				!modalForm.cash.isChecked &&
				!modalForm.zyPos.isChecked &&
				!modalForm.jpoint.isChecked
			) {
				this.$Utils.showTipInfo('請選擇付款方式')
				this.infoSubmiting = false
				return
			}
			
			this.isPaying = true
			data.odd_numbers = odd_numbers
			data.only_finish = this.onlysign
			
			if (Math.floor(this.delivery) > 0) {
				data.delivery = Math.floor(this.delivery)
			}
			if (Math.floor(this.modalForm.credit.value) > 0) {
				data.credit = Math.floor(this.modalForm.credit.value)
			}
			if (Math.floor(this.modalForm.cash.value) > 0) {
				data.cash = Math.floor(this.modalForm.cash.value)
			}
			if (Math.floor(this.modalForm.zyPos.value) > 0) {
				data.zyPos = Math.floor(this.modalForm.zyPos.value)
			}
			if (Math.floor(this.modalForm.mPay.value) > 0) {
				data.mPay = Math.floor(this.modalForm.mPay.value)
			}
			if (Math.floor(this.modalForm.aomentong.value) > 0) {
				data.aomentong = Math.floor(this.modalForm.aomentong.value)
			}
			if (Math.floor(this.modalForm.alipay.value) > 0) {
				data.alipay = Math.floor(this.modalForm.alipay.value)
			}
			if (Math.floor(this.modalForm.gyPos.value) > 0) {
				data.gyPos = Math.floor(this.modalForm.gyPos.value)
			}
			if (Math.floor(this.modalForm.wxpay.value) > 0) {
				data.wxpay = Math.floor(this.modalForm.wxpay.value)
			}
			if (modalForm.jpoint.isChecked) {
				console.log('jpoint')
				data.jpoint = Math.floor(this.modalForm.jpoint.value)
				this.$Rq.requestAuth({
					url: this.$Api.deliverySigntodo_jpoint,
					method: 'post',
					data: {
						order: odd_numbers,
						remark: this.remark
					},
				}).then(res => {
					this.infoSubmiting = false
					if (res.code === 0) {
						this.form.phone = ''
						this.$Utils.showSuccess(res.msg)
						let audio = new Audio()
						audio.src = require('@/assets/audio/' + this.successAudio)
						audio.play()
						this.isPaying = false
						isthis.sums = 0
						this.handleModalSignClose()
						this.getList(this.form.arrive)
					}else {
						this.$Modal.error({
							title: '警告',
							content: res.msg,
						})
						let audio = new Audio()
						audio.src = require('@/assets/audio/' + this.errorAudio)
						audio.play()
						this.isPaying = false
						isthis.sums = 0
					}
				}).catch(err => {
					this.isPaying = false
					this.infoSubmiting = false
				})
				
				return;
			}
			// data.outmany = this.checkOutTimePay;// 是否免超时费
			// data.additional_fee = this.checkAdditional;// 是否免附加费
			
			this.$Rq
				.requestAuth({
					url: this.$Api.deliverySigntodo,
					method: 'post',
					data: data,
				})
				.then((res) => {
					this.infoSubmiting = false
					if (res.code === 0) {
						this.form.phone = ''
						this.$Utils.showSuccess(res.msg)
						let audio = new Audio()
						audio.src = require('@/assets/audio/' + this.successAudio)
						audio.play()
						this.isPaying = false
						isthis.sums = 0
						this.handleModalSignClose()
						this.getList(this.form.arrive)
					} else {
						this.$Modal.error({
							title: '警告',
							content: res.msg,
						})
						let audio = new Audio()
						audio.src = require('@/assets/audio/' + this.errorAudio)
						audio.play()
						this.isPaying = false
						isthis.sums = 0
					}
				})
				.catch((err) => {
					this.infoSubmiting = false
				})
		},
		handlePageSizeChange(value) {
			this.pageIndex = 1
			isthis.sums = 0
			this.getList(this.form.arrive)
		},
		handlePageInput() {
			let value = ('' + this.pageInput).replace(/\D/g, '')
			let pageCount = Math.floor(this.totalCount / this.curPageSize)
			if (value > pageCount) {
				value = pageCount
			}
			isthis.sums = 0
			this.pageInput = value
		},
		handlePageEnter() {
			if (this.pageInput == '' || this.pageInput == this.pageIndex) return
			if (this.pageInput == 0) {
				this.pageInput = 1
			}
			this.pageInput = parseInt(this.pageInput)
			this.pageIndex = this.pageInput
			isthis.sums = 0
			this.getList(this.form.arrive)
		},
		handlePageChange(value) {
			this.pageIndex = value
			isthis.sums = 0
			this.getList(this.form.arrive)
		},
		handleSelectionChange() {
			let sums = 0,
				counter = 0
			this.curCheckedList = this.$refs.table.getSelection()
			this.curCheckedList.forEach((item) => {
				counter++
				if (item.pay_type == '未在APP內付款') {
					sums += parseFloat(item.sum) - parseFloat(item.outtimepay)
				} else {
					// sums += item.outtimepay
					sums += 0
				}
			})
			isthis.sums = Math.floor(sums)
			isthis.counter = counter
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'deliverSigntodo.scss';
</style>
<style>
.ivu-table td.demo-table-info-column {
	background-color: #ffebde;
	color: #000;
}

.ivu-table td.demo-table-info-cell-name {
	background-color: #d6e7ff;
	color: #515a6e;
}

.ivu-table td.demo-table-info-cell-name-sum {
	background-color: #ffebde;
	color: #000;
}

.ivu-table .demo-table-error-row {
	background-color: #fcffd6;
	color: #515a6e;
}

.ivu-table .demo-table-info-row {
	background-color: #ffebde;
	color: #515a6e;
}

.ivu-table .demo-table-app-row {
	background-color: #e8ffd6;
	color: #515a6e;
}
</style>
